import React, { memo, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { actions as callActions, selectors as callSelectors, } from '../../../../call';
import { hangUpParticipant, hideParticipantActions, muteParticipant, openChat, } from '../../../actions';
import { IconColors, IconSizes, IconVariants, } from '../../../constants';
import ButtonClose from '../../ButtonClose';
import Icon from '../../Icon';
import SwitchMic from '../../SwitchMic';
import SwitchPin from '../../SwitchPin';
import CommentIcon from '../../../assets/icons/comment.svg';
import PhoneIcon from '../../../assets/icons/phone.svg';
import './ParticipantActions.scss';
const DEFAULT_DELAY = 400;
const ParticipantActions = ({ participant }) => {
    const dispatch = useDispatch();
    const isPinned = useSelector((state) => callSelectors.isParticipantPinned(state, participant.id));
    const [isVisible, setVisible] = useState(true);
    let timeoutId;
    const closeHandle = useCallback(() => {
        setVisible(false);
        timeoutId = setTimeout(() => {
            dispatch(hideParticipantActions());
        }, DEFAULT_DELAY);
        return () => clearTimeout(timeoutId);
    }, []);
    const openChatHandle = useCallback(() => {
        dispatch(openChat(participant.uuid));
        closeHandle();
    }, [participant.uuid]);
    const muteHandle = useCallback(() => {
        if (!participant.hasAudio)
            return;
        dispatch(muteParticipant(participant.uuid));
        closeHandle();
    }, [participant.hasAudio, participant.uuid]);
    const hangUpHandle = useCallback(() => {
        dispatch(hangUpParticipant(participant.uuid, participant.id));
        closeHandle();
    }, [participant.uuid, participant.id]);
    const pinHandle = useCallback(() => {
        dispatch(callActions.pinStream(participant.id));
        closeHandle();
    }, [participant.id]);
    return (<div className={classnames({
            'ml-participant-actions': true,
            'ml-participant-actions--hidden': !isVisible
        })}>
      <div className="ml-participant-actions__content">
        <div className="ml-participant-actions__header">
          <div className="ml-participant-actions__header__title">
            {participant.name}
          </div>
          <div className="ml-participant-actions__header__close">
            <ButtonClose size={IconSizes.Medium} clickHandle={closeHandle}/>
          </div>
        </div>
        <div>
          <div className="ml-participant-actions__item" onClick={openChatHandle}>
            <div className="ml-participant-actions__item-icon">
              <Icon>
                <CommentIcon />
              </Icon>
            </div>
            <div className="ml-participant-actions__item-label">
              Send a direct message
            </div>
          </div>
          <div className={classnames({
            'ml-participant-actions__item': true,
            'ml-participant-actions__item--disabled': !participant.hasAudio
        })} onClick={muteHandle}>
            <div className="ml-participant-actions__item-icon">
              <SwitchMic isActive={participant.hasAudio} size={IconSizes.Medium} variant={IconVariants.Plain} disabled={true}/>
            </div>
            <div className="ml-participant-actions__item-label">
              {participant.hasAudio
            ? 'Mute'
            : 'Muted'}
            </div>
          </div>
          <div className="ml-participant-actions__item" onClick={pinHandle}>
            <div className='ml-participant-actions__item-icon'>
              <SwitchPin participantId={participant.id} disabled={true}/>
            </div>
            <div className='ml-participant-actions__item-label'>
              {isPinned
            ? 'Unpin from main view'
            : 'Pin to main view'}
            </div>
          </div>
          <div className="ml-participant-actions__item ml-participant-actions__item--danger" onClick={hangUpHandle}>
            <div className='ml-participant-actions__item-icon'>
              <Icon color={IconColors.Danger}>
                <PhoneIcon />
              </Icon>
            </div>
            <div className='ml-participant-actions__item-icon'>
              Hang up
            </div>
          </div>
        </div>
      </div>
    </div>);
};
export default memo(ParticipantActions);
